export default __webpack_public_path__ + "static/media/syncretic_logo_2.aef0bb6a.png";